import { func } from 'prop-types';
import Button from '@alltrails/shared/denali/components/Button';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    GIFT_FLOW: { BUY_GIFT, GIVE_A_GIFT_CARD, HELP_GET_ADVENTURE_STARTED }
  }
} = StringConstantsMixin;

const GiveAllTrailsBanner = ({ handleClick }) => {
  return (
    <section className={styles.container}>
      <h3 className={styles.header}>{GIVE_A_GIFT_CARD}</h3>
      <div className={styles.subText}>{HELP_GET_ADVENTURE_STARTED}</div>
      <Button text={BUY_GIFT} className={styles.button} onClick={handleClick} testId="gift-at-banner-buy-gift" variant="primary" />
    </section>
  );
};

GiveAllTrailsBanner.propTypes = {
  handleClick: func
};

GiveAllTrailsBanner.defaultProps = {
  handleClick: () => {}
};

export default GiveAllTrailsBanner;
